"use client";
import { ArrowRight } from "lucide-react";
import Image from "next/image";
const EligibilitySection = ({ data, onApplyNow }) => {
  const value = data.eligibility;

  return (
    <section className="relative page-container py-8 md:py-14 xl:py-17 mb-12 md:mb-20 xl:mb-25">
      <Image
        src="/images/EligibilityBackground.png"
        alt="Background pattern"
        fill
        objectFit="cover"
        className="z-0"
      />

      <div className="relative z-10 flex flex-col xl:flex-row xl:gap-2 items-center justify-between">

        <div className="text-black mb-5 md:mb-11">
          <h2 className="mb-3 text-[20px] md:text-[25px] lg:text-[30px] xl:text-[42px] font-bold">{value.title}</h2>
          <span
            className="text-black text-[18px] leading-6 md:text-[24px] md:leading-8 block font-normal w-full md:max-w-5xl"
            style={{ fontFamily: "saans-medium" }}
          >
            {value.description}
          </span>
        </div>

        {value.button && (

          <button
            onClick={onApplyNow}
            className="max-w-50 relative group cursor-pointer bg-[#081E2D] px-6 py-2 rounded-none
                    text-white text-lg font-semibold flex items-center justify-center gap-2
                    hover:bg-black transition"
          >
            {value.button.text}

            <ArrowRight
              size={25}
              className="transition-transform duration-300 rotate-45 group-hover:rotate-0"
            />
          </button>
        )}

      </div>
    </section>
  );
}

export default EligibilitySection;